var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnion(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 7,
    viewBox: "0 0 7 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33333 0.291748C2.27883 0.291748 2.22782 0.306698 2.18417 0.332722L0.146959 1.49684C0.0560834 1.54877 0 1.64541 0 1.75008V6.41675C0 6.52072 0.0553462 6.61683 0.145271 6.66901C0.235196 6.7212 0.346102 6.72157 0.436374 6.66999L2.34251 5.58076L4.53098 6.675C4.56884 6.69493 4.61162 6.70678 4.65702 6.70826C4.66023 6.70836 4.66345 6.70841 4.66667 6.70841C4.72117 6.70841 4.77218 6.69347 4.81582 6.66744L6.85304 5.50332C6.94392 5.45139 7 5.35475 7 5.25008V0.583415C7 0.479444 6.94465 0.383335 6.85473 0.331149C6.7648 0.278964 6.6539 0.278593 6.56363 0.330177L4.65749 1.4194L2.46902 0.325167C2.42849 0.303826 2.38232 0.291748 2.33333 0.291748ZM4.95833 5.91415L6.41667 5.08082V1.08601L4.95833 1.91934V5.91415ZM4.375 1.93034L2.625 1.05534V5.06982L4.375 5.94482V1.93034ZM0.583333 1.91934L2.04167 1.08601V5.08082L0.583333 5.91415V1.91934Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnion);
export default __webpack_public_path__ + "static/media/union.b2362a68c9dbb9794afb87af1b3c1840.svg";
export { ForwardRef as ReactComponent };